import React from 'react';
import PropTypes from 'prop-types';

import gridCalculator from './gridCalculator';

const Container = ({ children }) => {
  const styles = {
    container: {
      borderBox: 'border-box',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'table',
      clear: 'both',
      width: gridCalculator.MAX_WIDTH,
    },
  };
  return <div style={styles.container}>{children}</div>;
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Container;
